<script lang="ts">
  import { cn } from '$lib/utils';

  let className: string | undefined = undefined;
  export { className as class };

  export let notAnimated: boolean | undefined = undefined;
</script>

<div class={cn('relative w-full h-full', className, !notAnimated && 'animation-container')}>
  <svg
    class={cn(!notAnimated && 'animation-item')}
    width="100%"
    height="100%"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 26 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 12V15.5H11V12H9ZM2 15.5V12L0 12V15.5H2ZM5.5 19C3.567 19 2 17.433 2 15.5H0C0 18.5376 2.46243 21 5.5 21V19ZM5.5 21C8.53757 21 11 18.5376 11 15.5H9C9 17.433 7.433 19 5.5 19V21Z"
      fill="currentColor"
    />
    <path
      d="M17 15.5V12H15V15.5H17ZM24 12V15.5H26V12H24ZM20.5 19C18.567 19 17 17.433 17 15.5H15C15 18.5376 17.4624 21 20.5 21V19ZM20.5 21C23.5376 21 26 18.5376 26 15.5H24C24 17.433 22.433 19 20.5 19V21Z"
      fill="currentColor"
    />
    <line
      x1="2.20711"
      y1="12.2929"
      x2="8.20711"
      y2="18.2929"
      stroke="currentColor"
      stroke-width="2"
    />
    <line
      x1="17.2071"
      y1="12.2929"
      x2="23.2071"
      y2="18.2929"
      stroke="currentColor"
      stroke-width="2"
    />
    <line x1="1" y1="12" x2="25" y2="12" stroke="currentColor" stroke-width="2" />
    <path
      d="M2 5H4.5V3H2V5ZM2 15V5H0V15H2ZM2 3C0.895431 3 0 3.89543 0 5H2V5V3Z"
      fill="currentColor"
    />
    <path
      d="M21.5 5H24V3H21.5V5ZM24 5V16H26V5H24ZM24 5H26C26 3.89543 25.1046 3 24 3V5Z"
      fill="currentColor"
    />
  </svg>
  {#if !notAnimated}
    <svg
      class={cn('absolute inset-0', !notAnimated && 'animation-item')}
      style:animation-delay="-4s"
      width="100%"
      height="100%"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 26 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="2.20711"
        y1="12.2919"
        x2="8.20711"
        y2="18.2919"
        stroke="currentColor"
        stroke-width="2"
      />
      <line
        x1="17.2071"
        y1="12.2919"
        x2="23.2071"
        y2="18.2919"
        stroke="currentColor"
        stroke-width="2"
      />
      <line x1="8.99976" y1="15" x2="16.9998" y2="14.998" stroke="currentColor" stroke-width="2" />
      <circle cx="20.5" cy="15.499" r="4.5" stroke="currentColor" stroke-width="2" />
      <circle cx="5.5" cy="15.499" r="4.5" stroke="currentColor" stroke-width="2" />
      <path
        d="M2 4.99902H4.5V2.99902H2V4.99902ZM2 14.999V4.99902H0L0 14.999H2ZM2 2.99902C0.895431 2.99902 0 3.89445 0 4.99902H2V4.99902V2.99902Z"
        fill="currentColor"
      />
      <path
        d="M21.5 4.99902H24V2.99902H21.5V4.99902ZM24 4.99902V15.999H26V4.99902H24ZM24 4.99902H26C26 3.89445 25.1046 2.99902 24 2.99902V4.99902Z"
        fill="currentColor"
      />
    </svg>

    <svg
      class={cn('absolute inset-0', !notAnimated && 'animation-item')}
      style:animation-delay="-8s"
      width="100%"
      height="100%"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 26 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="2.20711"
        y1="12.2919"
        x2="8.20711"
        y2="18.2919"
        stroke="currentColor"
        stroke-width="2"
      />
      <line
        x1="17.2071"
        y1="12.2919"
        x2="23.2071"
        y2="18.2919"
        stroke="currentColor"
        stroke-width="2"
      />
      <line x1="8.99976" y1="15" x2="16.9998" y2="14.998" stroke="currentColor" stroke-width="2" />
      <path
        d="M2 4.99902H4.5V2.99902H2V4.99902ZM2 14.999V4.99902H0L0 14.999H2ZM2 2.99902C0.895431 2.99902 0 3.89445 0 4.99902H2V4.99902V2.99902Z"
        fill="currentColor"
      />
      <path
        d="M21.5 4.99902H24V2.99902H21.5V4.99902ZM24 4.99902V15.999H26V4.99902H24ZM24 4.99902H26C26 3.89445 25.1046 2.99902 24 2.99902V4.99902Z"
        fill="currentColor"
      />
      <path d="M16 13L20.5 11L25 13V18L20.5 20L16 18V13Z" stroke="currentColor" stroke-width="2" />
      <path d="M1 13L5.5 11L10 13V18L5.5 20L1 18V13Z" stroke="currentColor" stroke-width="2" />
    </svg>

    <svg
      class={cn('absolute inset-0', !notAnimated && 'animation-item')}
      style:animation-delay="-12s"
      width="100%"
      height="100%"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 26 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8 17L18 16.998" stroke="currentColor" stroke-width="2" />
      <path
        d="M0 13.999C0 14.5513 0.447715 14.999 1 14.999C1.55228 14.999 2 14.5513 2 13.999H0ZM2 4.99902H4.5V2.99902H2V4.99902ZM2 13.999L2 4.99902H0L0 13.999H2ZM2 2.99902C0.89543 2.99902 0 3.89445 0 4.99902H2L2 4.99902V2.99902Z"
        fill="currentColor"
      />
      <path
        d="M24 13.999C24 14.5513 24.4477 14.999 25 14.999C25.5523 14.999 26 14.5513 26 13.999H24ZM21.5 4.99902H24V2.99902H21.5V4.99902ZM24 4.99902V13.999H26V4.99902H24ZM24 4.99902L24 4.99902H26C26 3.89445 25.1046 2.99902 24 2.99902V4.99902Z"
        fill="currentColor"
      />
      <path
        d="M6.40416 10.3218C6.43254 10.2265 6.56746 10.2265 6.59584 10.3218L7.71354 14.0744C7.72617 14.1168 7.76515 14.1459 7.80938 14.1459H11.4436C11.5384 14.1459 11.58 14.2654 11.5058 14.3243L8.55104 16.6662C8.519 16.6916 8.50564 16.7339 8.51731 16.7731L9.64232 20.5503C9.67023 20.644 9.56098 20.7179 9.48437 20.6572L6.56211 18.341C6.52573 18.3122 6.47427 18.3122 6.43789 18.341L3.51563 20.6572C3.43902 20.7179 3.32977 20.644 3.35768 20.5503L4.48269 16.7731C4.49436 16.7339 4.481 16.6916 4.44896 16.6662L1.49424 14.3243C1.41998 14.2654 1.46159 14.1459 1.55635 14.1459H5.19062C5.23485 14.1459 5.27383 14.1168 5.28646 14.0744L6.40416 10.3218Z"
        stroke="currentColor"
        stroke-width="2"
      />
      <path
        d="M19.9035 10.3565C19.9301 10.258 20.0699 10.258 20.0965 10.3565L21.1026 14.072C21.1144 14.1156 21.1539 14.1459 21.1991 14.1459H24.4884C24.5808 14.1459 24.6238 14.2605 24.5541 14.3213L21.8635 16.6671C21.8347 16.6922 21.8227 16.7317 21.8327 16.7686L22.8528 20.5361C22.8787 20.6315 22.7651 20.7025 22.6906 20.6376L20.0657 18.3491C20.0281 18.3163 19.9719 18.3163 19.9343 18.3491L17.3094 20.6376C17.2349 20.7025 17.1213 20.6315 17.1472 20.5361L18.1673 16.7686C18.1773 16.7317 18.1653 16.6922 18.1365 16.6671L15.4459 14.3213C15.3762 14.2605 15.4192 14.1459 15.5116 14.1459H18.8009C18.8461 14.1459 18.8856 14.1156 18.8974 14.072L19.9035 10.3565Z"
        stroke="currentColor"
        stroke-width="2"
      />
    </svg>
  {/if}
</div>

<style>
  .animation-container {
    animation: animation-container-keyframes 4s cubic-bezier(0.68, -0.6, 0.32, 1.6) infinite;
  }

  @keyframes animation-container-keyframes {
    0%,
    60% {
      transform: rotate(0deg);
    }
    85% {
      transform: rotate(-40deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }

  .animation-item {
    animation: animation-item-keyframes 16s ease-in-out infinite;
  }

  @keyframes animation-item-keyframes {
    0%,
    25.15% {
      opacity: 1;
    }
    25.16%,
    100% {
      opacity: 0;
    }
  }
</style>
